var $8f565d9eaaeed303$exports = {};
// Mobile menu functionality
function $8f565d9eaaeed303$var$initMobileMenu() {
    const mobileMenuToggle = document.querySelector('.mobile-menu-toggle');
    const mainNav = document.querySelector('.main-nav');
    if (mobileMenuToggle && mainNav) {
        let isAnimating = false;
        // Handle toggle button click
        mobileMenuToggle.addEventListener('click', (e)=>{
            e.stopPropagation(); // Prevent event from bubbling up
            if (isAnimating) return;
            isAnimating = true;
            mobileMenuToggle.classList.toggle('active');
            mainNav.classList.toggle('active');
            // Reset animation flag after transition
            setTimeout(()=>{
                isAnimating = false;
            }, 300); // Match the transition duration
        });
        // Handle clicks on menu items
        mainNav.addEventListener('click', (e)=>{
            const target = e.target;
            // If clicking a menu item, close the menu
            if (target.tagName.toLowerCase() === 'a') {
                if (isAnimating) return;
                isAnimating = true;
                mobileMenuToggle.classList.remove('active');
                mainNav.classList.remove('active');
                // Reset animation flag after transition
                setTimeout(()=>{
                    isAnimating = false;
                }, 300);
            }
            e.stopPropagation(); // Prevent closing when clicking inside menu
        });
        // Close menu when clicking outside
        document.addEventListener('click', (e)=>{
            if (mainNav.classList.contains('active')) {
                const target = e.target;
                if (!mobileMenuToggle.contains(target) && !mainNav.contains(target)) {
                    if (isAnimating) return;
                    isAnimating = true;
                    mobileMenuToggle.classList.remove('active');
                    mainNav.classList.remove('active');
                    // Reset animation flag after transition
                    setTimeout(()=>{
                        isAnimating = false;
                    }, 300);
                }
            }
        });
        // Close menu on window resize (in case user switches to desktop view)
        window.addEventListener('resize', ()=>{
            if (window.innerWidth > 768) {
                mobileMenuToggle.classList.remove('active');
                mainNav.classList.remove('active');
            }
        });
    }
}
// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', ()=>{
    $8f565d9eaaeed303$var$initMobileMenu();
});


//# sourceMappingURL=dca_past.76f41fc6.js.map
